export const WHATSAPP_NUMBER = '5585987046533'
